import React from 'react'
import styled from 'styled-components'
import { BaseButton } from '../Section'

const WhiteBtn = styled(BaseButton)`		
	background: #000;
	color:#000;	
	& .icon{
		> svg{
			fill:#000;
		}
	}
	&:before {
		background: #fff;			
	}
	&:hover{
		color:#fff;	
		& .icon{
			> svg{
				fill:#fff;
			}
		}
	}
`
const WhiteButton = (props) => {
	const { icon, iconAfter, text, size } = props;
	return(
		<WhiteBtn className={`btn ${size ? `btn-${size}` : ''} `}>
			{ iconAfter ? (
				<>
					{ text && <span className='text'>{text}</span>}
					{ iconAfter && <span className='icon'>{iconAfter}</span>}
				</>
				):(
					<>
						{ icon && <span className='icon'>{icon}</span>}
						{ text && <span className='text'>{text}</span>}
					</>
				)
			}
		</WhiteBtn>
	)
}


export default WhiteButton

